export default {
  Actions: {
    ADVANCE_ONBOARDING_STATE_SUCCESS: 'onboardingState/ADVANCE_ONBOARDING_STATE_SUCCESS',
    BACK_ONBOARDING_STATE_SUCCESS: 'onboardingState/BACK_ONBOARDING_STATE_SUCCESS',
    UPDATE_ONBOARDING_STATE_SUCCESS: 'onboardingState/UPDATE_ONBOARDING_STATE_SUCCESS',
    UPDATE_TOPICS_IN_REDUX: 'onboardingState/UPDATE_TOPICS_IN_REDUX',
  },
};
